import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable indent */
/* eslint-disable max-len */

const GeoLocIcon = (
  {
    width,
    height,
    fill,
  },
) => (
  <SvgImg width={width} height={height} viewbox="0 0 24.2 39.56" title="Geoloc">
    <g id="Calque_2">
      <g id="Calque_1-2" fill={fill}>
        <path id="picto_localisation.svg_copie" d="M12.1,0C5.43,0,0,5.89,0,13.09,0,16,1.71,20.73,5.24,27.58c2.51,4.84,5,8.87,5.06,9l1.8,2.95,1.8-2.95c.09-.16,2.58-4.19,5.06-9C22.49,20.76,24.2,16,24.2,13.09,24.23,5.89,18.77,0,12.1,0Zm0,19.79A6.54,6.54,0,0,1,5.83,13,6.56,6.56,0,0,1,12.1,6.21,6.56,6.56,0,0,1,18.37,13,6.54,6.54,0,0,1,12.1,19.79Z" />
      </g>
    </g>
  </SvgImg>
  );

GeoLocIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};
GeoLocIcon.defaultProps = {
  width: undefined,
  height: undefined,
  fill: '#b6b6b6',
};
export default GeoLocIcon;
